
import {Vue, Component} from 'vue-property-decorator';

import {materiaApi} from '@/api';
import formHelper from '../../../js/materia/materia.helper';
import Empty from '@/components/Empty/index.vue';
import Authorize_Class from './materia_authorize.vue';

import moment from 'moment';

@Component({
    components: {
        Empty,
        Authorize_Class
    }
})
export default class Meteria_Class extends Vue {
    //===================================data区域begin
    courseId: any = '';
    courseName: any = '';
    schoolId: any = '';
    schoolName: any = '';

    classList: any = [];

    query: any = {
        condition: '',
        classId: '',
        associatedType: ''
    };
    columns: any = formHelper.columnsClass;
    pager: any = {
        default: {
            pagesize: 10,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    showClassAuthorize: boolean = false;
    classLoading: boolean = false;
    selectedRowKeys: any = [];
    source: any = [
        {
            label: '学校管理员关联',
            value: 'byAdmin'
        },
        {
            label: '教师手动添加',
            value: 'byTeacher'
        }
    ];
    classListReady: boolean = false;
    classSearchList: any = [];

    selectClassList: any = [];
    // 取消关联时查询正在上课的班级
    courseIsBeginning: any = [];
    //===================================data区域end
    //===================================computed区域begin
    get rowSelection() {
        return {
            columnWidth: '40px',
            //onChange方法，rowSelection改变时触发
            onChange: (selectedRowKeys: any) => {
                //获取选中行的key元素，和下面selectedRowKeys属性配合使用，表示给rowSelection绑定一个v-model，为this.selectedRowKeys
                this.selectedRowKeys = selectedRowKeys;
            },
            selectedRowKeys: this.selectedRowKeys,
            onSelect: (record: any, selected: boolean, selectedRows: any) => {
                if (selected) {
                    this.selectClassList.push(record);
                }

                if (!selected) {
                    for (let i = 0; i < this.selectClassList.length; i++) {
                        if (record._id == this.selectClassList[i]._id) {
                            this.selectClassList.splice(i, 1);
                        }
                    }
                }
            },
            // 用户手动选择/取消选择所有列的回调
            onSelectAll: (selected: boolean, selectedRows: any, changeRows: any) => {
                if (selected) {
                    selectedRows.forEach((el: any) => {
                        if (!this.selectClassList.some((e: any) => e._id == el._id)) {
                            this.selectClassList.push(el);
                        }
                    });
                } else {
                    for (let i = 0; i < changeRows.length; i++) {
                        for (let j = 0; j < this.selectClassList.length; j++) {
                            if (this.selectClassList[j]._id == changeRows[i]._id) {
                                this.selectClassList.splice(j, 1);
                            }
                        }
                    }
                }
            },
            // 表格默认状态
            getCheckboxProps: (record: any) => ({})
        };
    }
    //===================================computed区域end
    //===================================methods区域begin
    addClass() {
        this.showClassAuthorize = true;
    }
    changeClass(value: any) {
        this.query.classId = value;
        this.refreshClassList();
    }
    changeSource(value: any) {
        this.query.associatedType = value;
        this.refreshClassList();
    }
    // 取消关联
    handleDelete(flag: any, record: any) {
        // console.log(flag, record);
        let me = this;
        let pageData: any = {
            ids: []
        };
        if (flag == 'single') {
            pageData.ids.push(record._id);
        }
        if (flag == 'batch') {
            if (me.selectedRowKeys.length == 0) {
                me.$message.warning('请选择班级');
                return;
            }
            pageData.ids = me.selectedRowKeys;
        }
        me.$confirm({
            title: '提示',
            content: '取消关联后，班级师生将不可使用该课程，请谨慎操作。',
            centered: true,
            onOk() {
                if (flag == 'batch') {
                    let pageData2: any = {
                        classCourses: [],
                        allClassCourses: []
                    };
                    // console.log(me.selectClassList);
                    me.selectClassList.map((el: any) => {
                        pageData2.classCourses.push(Object.assign({}, {classId: el.classId, courseId: me.courseId}));
                        pageData2.allClassCourses.push(Object.assign({}, {classId: el.classId, courseId: me.courseId, _id: el._id}));
                    });
                    let pageData3: any = {
                        classCourses: []
                    };
                    pageData3.classCourses = pageData2.classCourses;
                    // console.log(pageData2);
                    materiaApi.getClassStatus({
                        context: me,
                        data: pageData3,
                        success(data: any) {
                            me.courseIsBeginning = [];
                            // console.log(data.data.results);
                            let dataList = data.data.results;
                            dataList.forEach((el: any) => {
                                if (el.classStatusCount > 0) {
                                    me.courseIsBeginning.push(el);
                                }
                            });
                            // console.log(me.courseIsBeginning);
                            // console.log(pageData2.allClassCourses);
                            if (me.courseIsBeginning.length > 0) {
                                let className = me.courseIsBeginning[0].className;
                                if (me.courseIsBeginning.length > 1) {
                                    for (let i = 1; i < me.courseIsBeginning.length; i++) {
                                        className += '、' + me.courseIsBeginning[i].className;
                                    }
                                }

                                me.$confirm({
                                    title: '批量取消冲突',
                                    okText: '跳过冲突课程并取消关联',
                                    content: `${className}正在开设当前课程，暂时无法取消。`,
                                    centered: true,
                                    onOk() {
                                        // 获取没有上课的班级
                                        const newData = pageData2.allClassCourses.filter(
                                            (l2: any) => me.courseIsBeginning.findIndex((l1: any) => l2.classId === l1.classId) === -1
                                        );
                                        pageData.ids = [];
                                        for (let l = 0; l < newData.length; l++) {
                                            pageData.ids.push(newData[l]._id);
                                        }

                                        if (newData.length > 0) {
                                            materiaApi.deleteCourseClass({
                                                context: me,
                                                data: pageData,
                                                success(data: any) {
                                                    me.$message.success(`操作成功！共${newData.length}门课程已被取消关联。`);
                                                    me.getList();
                                                }
                                            });
                                        }
                                        me.selectedRowKeys = [];
                                        me.courseIsBeginning = [];
                                        pageData2.classCourses = [];
                                        pageData2.allClassCourses = [];
                                        return;
                                    },
                                    onCancel() {
                                        me.selectedRowKeys = [];
                                        me.courseIsBeginning = [];
                                        pageData2.classCourses = [];
                                        pageData2.allClassCourses = [];
                                    }
                                });
                            } else {
                                pageData.ids = [];
                                for (let i = 0; i < pageData2.allClassCourses.length; i++) {
                                    pageData.ids.push(pageData2.allClassCourses[i]._id);
                                }
                                materiaApi.deleteCourseClass({
                                    context: me,
                                    data: pageData,
                                    success(data: any) {
                                        me.$message.success(`操作成功！共${pageData.ids.length}门课程已被取消关联。`);
                                        me.getList();
                                    }
                                });
                            }
                        },
                        error(error: any, message: string) {
                            me.$message.error(message);
                        }
                    });
                }
                if (flag == 'single') {
                    materiaApi.deleteCourseClass({
                        context: me,
                        data: pageData,
                        success(data: any) {
                            me.$message.success('操作成功！已取消该课程与班级的关联');
                            me.getList();
                        },
                        error(error: any, message: string) {
                            me.$message.error('操作失败！该课程正在上课中，暂不支持取消关联。');
                        }
                    });
                }
            },
            onCancel() {}
        });
    }
    refreshClassList() {
        this.pager.default.pagenum = 1;
        this.getList();
    }
    // 获取该课程关联的班级
    getList() {
        let me = this;
        me.classLoading = true;
        let data = {
            courseId: me.courseId,
            page: me.pager.default.pagenum,
            pagesize: me.pager.default.pagesize,
            classId: me.query.classId,
            associatedType: me.query.associatedType
        };
        materiaApi.getcheckboxGroupAndcheckAll({
            context: me,
            data: data,
            success(data: any) {
                // console.log(data.data.list);
                let dataList = data.data.list;
                if (data.data.total > 0) {
                    me.classList = dataList;
                    me.pager.default.total = data.data.total;

                    for (let i = 0; i < dataList.length; i++) {
                        if (!me.classListReady) {
                            me.classSearchList.push({});
                            me.classSearchList[i].label = dataList[i].className;
                            me.classSearchList[i].value = dataList[i].classId;
                        }
                        if (dataList[i].phases) {
                            if (dataList[i].phases[0] == 'primary') {
                                dataList[i].phases[0] = '小学';
                            } else if (dataList[i].phases[0] == 'junior') {
                                dataList[i].phases[0] = '初中';
                            } else if (dataList[i].phases[0] == 'senior') {
                                dataList[i].phases[0] = '高中';
                            }
                        }
                    }
                }
                // 班级搜索列表只获取一次
                me.classListReady = true;
                me.classLoading = false;
                me.pager.default.rows = dataList;
            },
            error(error: any, message: string) {
                me.$message.error(message);
                me.classLoading = false;
            }
        });
    }
    paginationChange(page: number, pageSize: number) {
        this.pager.default.pagenum = page;
        this.getList();
    }
    //===================================methods区域end
    created() {
        if (this.$route.query) {
            this.courseId = this.$route.query.courseId;
            this.courseName = this.$route.query.courseName;
        }
        let state = this.$app.getState();
        this.schoolId = state.schoolId;
        this.getList();
        // console.log(this);
    }
}
